import {
  ASYNC_START,
  ASYNC_END,
  REDIRECT,
  CHECK_CAMPAIGN_ITEM,
  CREATE_EVENT,
  LOCATE_PAGE_UNLOADED
} from "../constants/common.action.types";

export default (state = {}, action) => {
  switch (action.type) {
    case REDIRECT:
      return { ...state, redirectTo: null };
    case CREATE_EVENT:
      return {
        ...state,
        redirectTo: action.error ? null : "/thank"
      };
    case CHECK_CAMPAIGN_ITEM:
      return {
        ...state,
        itemResponse: action.error ? null : action.payload
      };
    case LOCATE_PAGE_UNLOADED:
      return {};
    case ASYNC_START:
      return { ...state, inProgress: true };
    case ASYNC_END:
      return { ...state, inProgress: false };
    default:
      return state;
  }
};
